const pdfjsLib = require('../../lib/pdfjs/pdf.mjs');
import PdfPageWithText from './types/PdfPageWithText.ts';

pdfjsLib.GlobalWorkerOptions.workerSrc = '/workers/pdf.worker.mjs';

/**
 * 
 * @param {Uint8Array<ArrayBufferLike>} pdf_bytes 
 * @returns {Array<PdfPageWithText>} canvas_container 
 */
export async function get_pdf_page_numbers_with_text(pdf_bytes) {
    let pdf_bytes_copy = new ArrayBuffer(pdf_bytes.byteLength);
    new Uint8Array(pdf_bytes_copy).set(new Uint8Array(pdf_bytes))

    const pdf_pages = [];
    let loadingTask = pdfjsLib.getDocument({data: pdf_bytes_copy});
    // let that = this;
    let pdf = await loadingTask.promise
    for (let page_number = 1; page_number <= pdf.numPages; page_number++) {
        //TODO: Add error catching
        const page = await pdf.getPage(page_number)
        //TODO: Add error catching
        const text_contents = await page.getTextContent()

        const text_contents_strings = text_contents.items.map((item) => {
            if(typeof item === 'object'
                && Object.hasOwn(item, 'str')
                && typeof item.str === 'string'
            ) {
                return item.str
            } else {
                return ''
            }
        })

        const pdf_page = {
            page_number: page_number,
            text_contents: text_contents_strings,
            text_contents_full: text_contents
        };

        pdf_pages.push(pdf_page);
    }

    return pdf_pages
}

/**
 * 
 * @param {Uint8Array<ArrayBufferLike>} pdf_bytes 
 * @param {HTMLElement} canvas_container
 * @returns {Promise<void>}
 */
export async function render_pdf(pdf_bytes, canvas_container) {
    const scale = 1.3333333333333333333333333333333
    let pdf_bytes_copy = new ArrayBuffer(pdf_bytes.byteLength);
    new Uint8Array(pdf_bytes_copy).set(new Uint8Array(pdf_bytes))

    let loadingTask = pdfjsLib.getDocument({data: pdf_bytes_copy});

    return new Promise((resolve, reject) => {
        loadingTask.promise.then((pdf) => {
            for (let page_number = 1; page_number <= pdf.numPages; page_number++) {
                pdf.getPage(page_number).then((page) => {
                    let viewport = page.getViewport({scale: scale});
                    // Prepare canvas using PDF page dimensions
    
                    let canvas = document.createElement('canvas');
                    
                    if (canvas_container !== null) {
                        canvas_container.appendChild(canvas)
                    }
                    let context = canvas.getContext('2d');
    
                    canvas.width = viewport.width;
                    canvas.height = viewport.height;
    
                    // Render PDF page into canvas context
                    let render_context = {
                        canvasContext: context,
                        viewport: viewport
                    };

                    let render_task = page.render(render_context);
    
                    render_task.promise
                        .then(() => {
                            resolve();
                        })
                        .catch((reason) => {
                            reject(reason)
                        });
                })
                .catch((reason) => {
                    reject(reason)
                });
            }
    
        }, (reason) => {
            reject(reason)
        });
    })
}